"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.approveReply = approveReply;
exports.approveTopic = approveTopic;
exports.assignBugStatus = assignBugStatus;
exports.assignIdeaStatus = assignIdeaStatus;
exports.assignModerator = assignModerator;
exports.changeAuthor = changeAuthor;
exports.changeCategory = changeCategory;
exports.convert = convert;
exports.copyTopicToForum = copyTopicToForum;
exports.deletePoll = deletePoll;
exports.editPollOptions = editPollOptions;
exports.editPollTitle = editPollTitle;
exports.editPublicLabel = editPublicLabel;
exports.getBugStatuses = getBugStatuses;
exports.getContentType = getContentType;
exports.getIdeaStatuses = getIdeaStatuses;
exports.getModerationLabels = getModerationLabels;
exports.getModeratorTagSuggestions = getModeratorTagSuggestions;
exports.getPageFromPostId = getPageFromPostId;
exports.getPoll = getPoll;
exports.getPrivateId = getPrivateId;
exports.getReplies = getReplies;
exports.getReply = getReply;
exports.getTopic = getTopic;
exports.getTopicByUrl = getTopicByUrl;
exports.getTopicCardFromUrl = void 0;
exports.getTopicWithReplies = getTopicWithReplies;
exports.like = like;
exports.markAsReadByTeam = markAsReadByTeam;
exports.markAsUnreadByTeam = markAsUnreadByTeam;
exports.markBestAnswer = markBestAnswer;
exports.mergeVotes = mergeVotes;
exports.moveRepliesToExistingTopic = moveRepliesToExistingTopic;
exports.moveTopicToExistingTopic = moveTopicToExistingTopic;
exports.pinReply = pinReply;
exports.promoteReply = promoteReply;
exports.removeCategory = removeCategory;
exports.replyToTopic = replyToTopic;
exports.resolveReply = resolveReply;
exports.resolveTopic = resolveTopic;
exports.toggleReplyTrashed = toggleReplyTrashed;
exports.toggleTrashed = toggleTrashed;
exports.unassignModerator = unassignModerator;
exports.unlike = unlike;
exports.unmarkBestAnswer = unmarkBestAnswer;
exports.unpinReply = unpinReply;
exports.unvote = unvote;
exports.vote = vote;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _qs = _interopRequireDefault(require("qs"));

var _contentType = require("@insided/shared/utils/contentType");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _string = require("@insided/deprecated-preact-components/utils/string");

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

function getTopic(_x, _x2) {
  return _getTopic.apply(this, arguments);
}

function _getTopic() {
  _getTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(contentType, privateId) {
    var _yield$axios$get2, data;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.get("/community/api/".concat(contentType, "s/").concat(privateId));

          case 2:
            _yield$axios$get2 = _context2.sent;
            data = _yield$axios$get2.data;
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getTopic.apply(this, arguments);
}

function getPoll(_x3, _x4) {
  return _getPoll.apply(this, arguments);
}

function _getPoll() {
  _getPoll = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(contentType, privateId) {
    var _yield$axios$get3, data;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.get("/community/api/".concat(contentType, "s/").concat(privateId, "/poll"));

          case 2:
            _yield$axios$get3 = _context3.sent;
            data = _yield$axios$get3.data;
            return _context3.abrupt("return", data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getPoll.apply(this, arguments);
}

function getReply(_x5, _x6, _x7) {
  return _getReply.apply(this, arguments);
}

function _getReply() {
  _getReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(contentType, privateId, replyId) {
    var _yield$axios$get4, data;

    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _axios.default.get("/community/api/".concat(contentType, "s/").concat(privateId, "/replies/").concat(replyId));

          case 2:
            _yield$axios$get4 = _context4.sent;
            data = _yield$axios$get4.data;
            return _context4.abrupt("return", data);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getReply.apply(this, arguments);
}

function getReplies(_x8, _x9, _x10, _x11, _x12) {
  return _getReplies.apply(this, arguments);
}

function _getReplies() {
  _getReplies = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(contentType, privateId, page, pageSize, sort) {
    var parameters, _yield$axios$get5, data;

    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            parameters = _qs.default.stringify({
              page: page,
              pageSize: pageSize,
              sort: sort
            }, {
              addQueryPrefix: true
            });
            _context5.next = 3;
            return _axios.default.get("/community/api/".concat(contentType, "s/").concat(privateId, "/replies").concat(parameters));

          case 3:
            _yield$axios$get5 = _context5.sent;
            data = _yield$axios$get5.data;
            return _context5.abrupt("return", data);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getReplies.apply(this, arguments);
}

function getTopicWithReplies(_x13, _x14, _x15, _x16, _x17) {
  return _getTopicWithReplies.apply(this, arguments);
}

function _getTopicWithReplies() {
  _getTopicWithReplies = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(publicTopicId, publicReplyId, page, pageSize, sort) {
    var parameters, _yield$axios$post, data;

    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            parameters = _qs.default.stringify({
              page: page,
              pageSize: pageSize,
              sort: sort
            }, {
              addQueryPrefix: true
            });
            _context6.next = 3;
            return _axios.default.post("/getTopicWithReplies".concat(parameters), {
              publicId: publicTopicId,
              publicReplyId: publicReplyId
            });

          case 3:
            _yield$axios$post = _context6.sent;
            data = _yield$axios$post.data;
            return _context6.abrupt("return", data);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getTopicWithReplies.apply(this, arguments);
}

function replyToTopic(_x18, _x19, _x20, _x21) {
  return _replyToTopic.apply(this, arguments);
}

function _replyToTopic() {
  _replyToTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(contentType, privateId, content, parentId) {
    var payload;
    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            payload = {
              content: content
            };

            if (typeof parentId === 'number' && !Number.isNaN(parentId)) {
              payload.parentId = parentId;
            }

            _context7.next = 4;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/reply"), payload);

          case 4:
            return _context7.abrupt("return", _context7.sent);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _replyToTopic.apply(this, arguments);
}

function like(_x22, _x23, _x24) {
  return _like.apply(this, arguments);
}

function _like() {
  _like = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(contentType, privateId, likedBy) {
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/like"), {
              likedBy: likedBy
            });

          case 2:
            return _context8.abrupt("return", _context8.sent);

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _like.apply(this, arguments);
}

function unlike(_x25, _x26, _x27) {
  return _unlike.apply(this, arguments);
}

function _unlike() {
  _unlike = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(contentType, privateId, unlikedBy) {
    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/unlike"), {
              unlikedBy: unlikedBy
            });

          case 2:
            return _context9.abrupt("return", _context9.sent);

          case 3:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _unlike.apply(this, arguments);
}

function vote(_x28, _x29, _x30) {
  return _vote.apply(this, arguments);
}

function _vote() {
  _vote = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(contentType, privateId, votedBy) {
    return _regenerator.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/vote"), {
              votedBy: votedBy
            });

          case 2:
            return _context10.abrupt("return", _context10.sent);

          case 3:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _vote.apply(this, arguments);
}

function unvote(_x31, _x32, _x33) {
  return _unvote.apply(this, arguments);
}

function _unvote() {
  _unvote = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(contentType, privateId, unvotedBy) {
    return _regenerator.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/unvote"), {
              unvotedBy: unvotedBy
            });

          case 2:
            return _context11.abrupt("return", _context11.sent);

          case 3:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _unvote.apply(this, arguments);
}

function mergeVotes(_x34, _x35, _x36) {
  return _mergeVotes.apply(this, arguments);
}

function _mergeVotes() {
  _mergeVotes = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(contentType, fromPrivateId, toPrivateId) {
    return _regenerator.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(fromPrivateId, "/mergeVotes"), {
              toIdeaId: toPrivateId
            });

          case 2:
            return _context12.abrupt("return", _context12.sent);

          case 3:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _mergeVotes.apply(this, arguments);
}

function assignIdeaStatus(_x37, _x38, _x39) {
  return _assignIdeaStatus.apply(this, arguments);
}

function _assignIdeaStatus() {
  _assignIdeaStatus = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(contentType, privateId, ideaStatusId) {
    return _regenerator.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/assignIdeaStatus"), {
              ideaStatusId: ideaStatusId
            });

          case 2:
            return _context13.abrupt("return", _context13.sent);

          case 3:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _assignIdeaStatus.apply(this, arguments);
}

function assignModerator(_x40, _x41, _x42) {
  return _assignModerator.apply(this, arguments);
}

function _assignModerator() {
  _assignModerator = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(contentType, privateIds, moderatorId) {
    var _axios$post;

    return _regenerator.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/assignModerator"), (_axios$post = {}, (0, _defineProperty2.default)(_axios$post, "".concat(contentType, "Ids"), privateIds), (0, _defineProperty2.default)(_axios$post, "assignedTo", moderatorId), _axios$post));

          case 2:
            return _context14.abrupt("return", _context14.sent);

          case 3:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _assignModerator.apply(this, arguments);
}

function unassignModerator(_x43, _x44) {
  return _unassignModerator.apply(this, arguments);
}

function _unassignModerator() {
  _unassignModerator = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(contentType, privateIds) {
    return _regenerator.default.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/unassignModerator"), (0, _defineProperty2.default)({}, "".concat(contentType, "Ids"), privateIds));

          case 2:
            return _context15.abrupt("return", _context15.sent);

          case 3:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _unassignModerator.apply(this, arguments);
}

function editPollTitle(_x45, _x46, _x47) {
  return _editPollTitle.apply(this, arguments);
}

function _editPollTitle() {
  _editPollTitle = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(contentType, privateId, title) {
    return _regenerator.default.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editPollTitle"), {
              title: title
            });

          case 2:
            return _context16.abrupt("return", _context16.sent);

          case 3:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _editPollTitle.apply(this, arguments);
}

function editPollOptions(_x48, _x49, _x50) {
  return _editPollOptions.apply(this, arguments);
}

function _editPollOptions() {
  _editPollOptions = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(contentType, privateId, options) {
    return _regenerator.default.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editPollOptions"), {
              options: options
            });

          case 2:
            return _context17.abrupt("return", _context17.sent);

          case 3:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _editPollOptions.apply(this, arguments);
}

function deletePoll(_x51, _x52) {
  return _deletePoll.apply(this, arguments);
}

function _deletePoll() {
  _deletePoll = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(contentType, privateId) {
    return _regenerator.default.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return _axios.default.delete("/community/api/".concat(contentType, "s/").concat(privateId, "/poll"), {
              data: {
                csrfToken: (0, _csrfToken.csrfToken)()
              }
            });

          case 2:
            return _context18.abrupt("return", _context18.sent);

          case 3:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _deletePoll.apply(this, arguments);
}

function changeCategory(_x53, _x54, _x55) {
  return _changeCategory.apply(this, arguments);
}

function _changeCategory() {
  _changeCategory = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(privateId, contentType, categoryId) {
    return _regenerator.default.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/move"), {
              categoryId: categoryId
            });

          case 2:
            return _context19.abrupt("return", _context19.sent);

          case 3:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _changeCategory.apply(this, arguments);
}

function removeCategory(_x56, _x57) {
  return _removeCategory.apply(this, arguments);
}

function _removeCategory() {
  _removeCategory = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(privateId, contentType) {
    return _regenerator.default.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/removeCategory"));

          case 2:
            return _context20.abrupt("return", _context20.sent);

          case 3:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _removeCategory.apply(this, arguments);
}

function editPublicLabel(_x58, _x59, _x60) {
  return _editPublicLabel.apply(this, arguments);
}

function _editPublicLabel() {
  _editPublicLabel = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21(contentType, privateId, publicLabel) {
    return _regenerator.default.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editPublicLabel"), {
              publicLabel: publicLabel
            });

          case 2:
            return _context21.abrupt("return", _context21.sent);

          case 3:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _editPublicLabel.apply(this, arguments);
}

function changeAuthor(_x61, _x62, _x63) {
  return _changeAuthor.apply(this, arguments);
}

function _changeAuthor() {
  _changeAuthor = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22(contentType, privateId, authorId) {
    return _regenerator.default.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/changeAuthor"), {
              authorId: authorId
            });

          case 2:
            return _context22.abrupt("return", _context22.sent);

          case 3:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _changeAuthor.apply(this, arguments);
}

function toggleTrashed(_x64, _x65, _x66) {
  return _toggleTrashed.apply(this, arguments);
}

function _toggleTrashed() {
  _toggleTrashed = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(contentType, privateId, trashed) {
    return _regenerator.default.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/toggleTrashed"), {
              trashed: trashed
            });

          case 2:
            return _context23.abrupt("return", _context23.sent);

          case 3:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _toggleTrashed.apply(this, arguments);
}

function toggleReplyTrashed(_x67, _x68, _x69) {
  return _toggleReplyTrashed.apply(this, arguments);
}

function _toggleReplyTrashed() {
  _toggleReplyTrashed = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee24(contentType, replyId, trashed) {
    return _regenerator.default.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _context24.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/toggleTrashed"), {
              trashed: trashed
            });

          case 2:
            return _context24.abrupt("return", _context24.sent);

          case 3:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
  return _toggleReplyTrashed.apply(this, arguments);
}

function convert(_x70, _x71, _x72, _x73) {
  return _convert.apply(this, arguments);
}

function _convert() {
  _convert = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee25(contentType, privateId, newContentType, categoryId) {
    var exceptionTypes, endpoint;
    return _regenerator.default.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            // for question to conversation conversion and vice versa the endpoint is /convert
            // for other content type conversions the endpoint is /convertTo[ContentType]
            exceptionTypes = [_contentType.CONTENT_TYPE_QUESTION, _contentType.CONTENT_TYPE_CONVERSATION];
            endpoint = exceptionTypes.includes(contentType) && exceptionTypes.includes(newContentType) ? "/community/api/".concat(contentType, "s/").concat(privateId, "/convert") : "/community/api/".concat(contentType, "s/").concat(privateId, "/convertTo").concat((0, _string.capitalize)(newContentType));

            if (!categoryId) {
              _context25.next = 6;
              break;
            }

            _context25.next = 5;
            return _axios.default.post(endpoint, {
              categoryId: categoryId
            });

          case 5:
            return _context25.abrupt("return", _context25.sent);

          case 6:
            _context25.next = 8;
            return _axios.default.post(endpoint);

          case 8:
            return _context25.abrupt("return", _context25.sent);

          case 9:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));
  return _convert.apply(this, arguments);
}

function approveTopic(_x74, _x75) {
  return _approveTopic.apply(this, arguments);
}

function _approveTopic() {
  _approveTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee26(contentType, privateId) {
    return _regenerator.default.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            _context26.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/approve"));

          case 2:
            return _context26.abrupt("return", _context26.sent);

          case 3:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));
  return _approveTopic.apply(this, arguments);
}

function approveReply(_x76, _x77) {
  return _approveReply.apply(this, arguments);
}

function _approveReply() {
  _approveReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee27(contentType, replyId) {
    return _regenerator.default.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            _context27.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/approve"));

          case 2:
            return _context27.abrupt("return", _context27.sent);

          case 3:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));
  return _approveReply.apply(this, arguments);
}

function resolveTopic(_x78, _x79) {
  return _resolveTopic.apply(this, arguments);
}

function _resolveTopic() {
  _resolveTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee28(contentType, privateId) {
    var userId;
    return _regenerator.default.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            userId = (0, _insidedDataStorage.getInsidedData)('user').userid;
            _context28.next = 3;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/resolve?resolvedBy=").concat(userId));

          case 3:
            return _context28.abrupt("return", _context28.sent);

          case 4:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }));
  return _resolveTopic.apply(this, arguments);
}

function resolveReply(_x80, _x81) {
  return _resolveReply.apply(this, arguments);
}

function _resolveReply() {
  _resolveReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee29(contentType, replyId) {
    var userId;
    return _regenerator.default.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            userId = (0, _insidedDataStorage.getInsidedData)('user').userid;
            _context29.next = 3;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/resolve?resolvedBy=").concat(userId));

          case 3:
            return _context29.abrupt("return", _context29.sent);

          case 4:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29);
  }));
  return _resolveReply.apply(this, arguments);
}

function pinReply(_x82, _x83) {
  return _pinReply.apply(this, arguments);
}

function _pinReply() {
  _pinReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee30(contentType, replyId) {
    return _regenerator.default.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            _context30.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/pin"));

          case 2:
            return _context30.abrupt("return", _context30.sent);

          case 3:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30);
  }));
  return _pinReply.apply(this, arguments);
}

function unpinReply(_x84, _x85) {
  return _unpinReply.apply(this, arguments);
}

function _unpinReply() {
  _unpinReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee31(contentType, replyId) {
    return _regenerator.default.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            _context31.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/unpin"));

          case 2:
            return _context31.abrupt("return", _context31.sent);

          case 3:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31);
  }));
  return _unpinReply.apply(this, arguments);
}

function moveTopicToExistingTopic(_x86, _x87, _x88, _x89) {
  return _moveTopicToExistingTopic.apply(this, arguments);
}

function _moveTopicToExistingTopic() {
  _moveTopicToExistingTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee32(contentType, fromTopicId, toTopicId, toTopicType) {
    return _regenerator.default.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            _context32.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(fromTopicId, "/moveToTopic"), {
              topicId: toTopicId,
              topicType: toTopicType
            });

          case 2:
            return _context32.abrupt("return", _context32.sent);

          case 3:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32);
  }));
  return _moveTopicToExistingTopic.apply(this, arguments);
}

function moveRepliesToExistingTopic(_x90, _x91, _x92, _x93) {
  return _moveRepliesToExistingTopic.apply(this, arguments);
}

function _moveRepliesToExistingTopic() {
  _moveRepliesToExistingTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee33(repliesContentType, replyIds, topicId, topicContentType) {
    return _regenerator.default.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            _context33.next = 2;
            return _axios.default.post('/community/api/replies/move', {
              repliesContentType: repliesContentType,
              replyIds: replyIds,
              topicId: topicId,
              topicContentType: topicContentType
            });

          case 2:
            return _context33.abrupt("return", _context33.sent);

          case 3:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33);
  }));
  return _moveRepliesToExistingTopic.apply(this, arguments);
}

function promoteReply(_x94, _x95, _x96, _x97) {
  return _promoteReply.apply(this, arguments);
}

function _promoteReply() {
  _promoteReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee34(contentType, replyId, title, categoryId) {
    var response;
    return _regenerator.default.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            _context34.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/promote"), {
              title: title,
              categoryId: categoryId
            });

          case 2:
            response = _context34.sent;
            return _context34.abrupt("return", getTopicIdFromResponse(response));

          case 4:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34);
  }));
  return _promoteReply.apply(this, arguments);
}

function copyTopicToForum(_x98, _x99, _x100) {
  return _copyTopicToForum.apply(this, arguments);
}

function _copyTopicToForum() {
  _copyTopicToForum = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee35(contentType, topicId, categoryIds) {
    return _regenerator.default.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            _context35.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(topicId, "/copy"), {
              categoryIds: categoryIds
            });

          case 2:
            return _context35.abrupt("return", _context35.sent);

          case 3:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35);
  }));
  return _copyTopicToForum.apply(this, arguments);
}

function markBestAnswer(_x101, _x102) {
  return _markBestAnswer.apply(this, arguments);
}

function _markBestAnswer() {
  _markBestAnswer = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee36(contentType, replyId) {
    return _regenerator.default.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            _context36.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/answer"));

          case 2:
            return _context36.abrupt("return", _context36.sent);

          case 3:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36);
  }));
  return _markBestAnswer.apply(this, arguments);
}

function unmarkBestAnswer(_x103, _x104) {
  return _unmarkBestAnswer.apply(this, arguments);
}

function _unmarkBestAnswer() {
  _unmarkBestAnswer = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee37(contentType, replyId) {
    return _regenerator.default.wrap(function _callee37$(_context37) {
      while (1) {
        switch (_context37.prev = _context37.next) {
          case 0:
            _context37.next = 2;
            return _axios.default.delete("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/answer"), {
              data: {
                csrfToken: (0, _csrfToken.csrfToken)()
              }
            });

          case 2:
            return _context37.abrupt("return", _context37.sent);

          case 3:
          case "end":
            return _context37.stop();
        }
      }
    }, _callee37);
  }));
  return _unmarkBestAnswer.apply(this, arguments);
}

function markAsReadByTeam(_x105, _x106) {
  return _markAsReadByTeam.apply(this, arguments);
}

function _markAsReadByTeam() {
  _markAsReadByTeam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee38(contentType, privateId) {
    return _regenerator.default.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            _context38.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/markAsReadByTeam"));

          case 2:
            return _context38.abrupt("return", _context38.sent);

          case 3:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38);
  }));
  return _markAsReadByTeam.apply(this, arguments);
}

function markAsUnreadByTeam(_x107, _x108) {
  return _markAsUnreadByTeam.apply(this, arguments);
}

function _markAsUnreadByTeam() {
  _markAsUnreadByTeam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee39(contentType, privateId) {
    return _regenerator.default.wrap(function _callee39$(_context39) {
      while (1) {
        switch (_context39.prev = _context39.next) {
          case 0:
            _context39.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/markAsUnreadByTeam"));

          case 2:
            return _context39.abrupt("return", _context39.sent);

          case 3:
          case "end":
            return _context39.stop();
        }
      }
    }, _callee39);
  }));
  return _markAsUnreadByTeam.apply(this, arguments);
}

function getPrivateId(_x109) {
  return _getPrivateId.apply(this, arguments);
}

function _getPrivateId() {
  _getPrivateId = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee40(publicId) {
    var _yield$axios$get6, privateId;

    return _regenerator.default.wrap(function _callee40$(_context40) {
      while (1) {
        switch (_context40.prev = _context40.next) {
          case 0:
            _context40.next = 2;
            return _axios.default.get("/topic/privateId/".concat(publicId));

          case 2:
            _yield$axios$get6 = _context40.sent;
            privateId = _yield$axios$get6.data.privateId;
            return _context40.abrupt("return", privateId);

          case 5:
          case "end":
            return _context40.stop();
        }
      }
    }, _callee40);
  }));
  return _getPrivateId.apply(this, arguments);
}

function getContentType(_x110) {
  return _getContentType.apply(this, arguments);
}

function _getContentType() {
  _getContentType = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee41(publicId) {
    var _yield$axios$get7, contentType;

    return _regenerator.default.wrap(function _callee41$(_context41) {
      while (1) {
        switch (_context41.prev = _context41.next) {
          case 0:
            _context41.next = 2;
            return _axios.default.get("/topic/contentType?publicId=".concat(publicId));

          case 2:
            _yield$axios$get7 = _context41.sent;
            contentType = _yield$axios$get7.data.contentType;
            return _context41.abrupt("return", contentType);

          case 5:
          case "end":
            return _context41.stop();
        }
      }
    }, _callee41);
  }));
  return _getContentType.apply(this, arguments);
}

function getModerationLabels() {
  return _getModerationLabels.apply(this, arguments);
}

function _getModerationLabels() {
  _getModerationLabels = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee42() {
    var _yield$axios$get8, data;

    return _regenerator.default.wrap(function _callee42$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            _context42.next = 2;
            return _axios.default.get('/settings/label/getLabels');

          case 2:
            _yield$axios$get8 = _context42.sent;
            data = _yield$axios$get8.data;
            return _context42.abrupt("return", data);

          case 5:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee42);
  }));
  return _getModerationLabels.apply(this, arguments);
}

function getIdeaStatuses() {
  return _getIdeaStatuses.apply(this, arguments);
}

function _getIdeaStatuses() {
  _getIdeaStatuses = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee43() {
    var _yield$axios$get9, data;

    return _regenerator.default.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            _context43.next = 2;
            return _axios.default.get('/community/api/ideas/ideaStatuses');

          case 2:
            _yield$axios$get9 = _context43.sent;
            data = _yield$axios$get9.data;
            return _context43.abrupt("return", data.result);

          case 5:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43);
  }));
  return _getIdeaStatuses.apply(this, arguments);
}

function getBugStatuses() {
  return _getBugStatuses.apply(this, arguments);
}

function _getBugStatuses() {
  _getBugStatuses = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee44() {
    var _yield$axios$get10, data;

    return _regenerator.default.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            _context44.next = 2;
            return _axios.default.get('/community/api/contentStatuses', {
              params: {
                context: 'bug'
              }
            });

          case 2:
            _yield$axios$get10 = _context44.sent;
            data = _yield$axios$get10.data;
            return _context44.abrupt("return", data.map(function (status) {
              return {
                id: String(status.id),
                name: status.name,
                backgroundColor: status.backgroundColor,
                textColor: status.textColor,
                visible: true
              };
            }));

          case 5:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44);
  }));
  return _getBugStatuses.apply(this, arguments);
}

function assignBugStatus(_x111, _x112, _x113) {
  return _assignBugStatus.apply(this, arguments);
}

function _assignBugStatus() {
  _assignBugStatus = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee45(contentType, privateId, bugStatusId) {
    return _regenerator.default.wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            _context45.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/assignBugStatus"), {
              bugStatusId: Number(bugStatusId)
            });

          case 2:
            return _context45.abrupt("return", _context45.sent);

          case 3:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45);
  }));
  return _assignBugStatus.apply(this, arguments);
}

function getTopicByUrl(_x114) {
  return _getTopicByUrl.apply(this, arguments);
}

function _getTopicByUrl() {
  _getTopicByUrl = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee46(topicUrl) {
    var _yield$axios$get11, data;

    return _regenerator.default.wrap(function _callee46$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            _context46.next = 2;
            return _axios.default.get("/topic/checkurl?checkurl=".concat(topicUrl));

          case 2:
            _yield$axios$get11 = _context46.sent;
            data = _yield$axios$get11.data;
            return _context46.abrupt("return", data);

          case 5:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee46);
  }));
  return _getTopicByUrl.apply(this, arguments);
}

function getPageFromPostId(_x115, _x116) {
  return _getPageFromPostId.apply(this, arguments);
}

function _getPageFromPostId() {
  _getPageFromPostId = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee47(topicPublicId, replyPublicId) {
    var _data$page, _yield$axios$get12, data;

    return _regenerator.default.wrap(function _callee47$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            _context47.prev = 0;
            _context47.next = 3;
            return _axios.default.get('/topic/getpostpage', {
              params: {
                post_id: replyPublicId,
                thread_id: topicPublicId
              }
            });

          case 3:
            _yield$axios$get12 = _context47.sent;
            data = _yield$axios$get12.data;
            return _context47.abrupt("return", (_data$page = data.page) !== null && _data$page !== void 0 ? _data$page : 1);

          case 8:
            _context47.prev = 8;
            _context47.t0 = _context47["catch"](0);
            return _context47.abrupt("return", undefined);

          case 11:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee47, null, [[0, 8]]);
  }));
  return _getPageFromPostId.apply(this, arguments);
}

var getTopicCardFromUrl = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(topicUrl) {
    var _yield$axios$get, data;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.get("/oembed/getEmbeddedUrl?url=".concat(encodeURIComponent(topicUrl)));

          case 2:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getTopicCardFromUrl(_x117) {
    return _ref.apply(this, arguments);
  };
}();

exports.getTopicCardFromUrl = getTopicCardFromUrl;

function getModeratorTagSuggestions(_x118) {
  return _getModeratorTagSuggestions.apply(this, arguments);
}

function _getModeratorTagSuggestions() {
  _getModeratorTagSuggestions = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee48(query) {
    var url, _yield$axios$get13, data;

    return _regenerator.default.wrap(function _callee48$(_context48) {
      while (1) {
        switch (_context48.prev = _context48.next) {
          case 0:
            url = query ? "/overview/listModeratorTags?q=".concat(encodeURIComponent(query)) : '/overview/listModeratorTags';
            _context48.next = 3;
            return _axios.default.get(url);

          case 3:
            _yield$axios$get13 = _context48.sent;
            data = _yield$axios$get13.data;
            return _context48.abrupt("return", data.map(function (tag) {
              return tag.name;
            }));

          case 6:
          case "end":
            return _context48.stop();
        }
      }
    }, _callee48);
  }));
  return _getModeratorTagSuggestions.apply(this, arguments);
}

function getTopicIdFromResponse(response) {
  var _response$headers$loc;

  var location = (_response$headers$loc = response.headers.location) !== null && _response$headers$loc !== void 0 ? _response$headers$loc : '';
  return Number(location.split('/')[3]);
}